<template>
    <v-main>
        <v-row justify="space-between">
            <v-col md="6" sm="12" cols="12" lg="6">
                <MainFilter @onInputChange="filterInputChanged" @onClick="toggleFilter" />
            </v-col>
            <v-col md="6" sm="12" cols="12" lg="6" align="right">
                <v-btn
                    @click="onClickNewOutgo"
                    depressed
                    class="white--text"
                    color="secondary"
                    x-large
                    :title="$tc('outgo.new')"
                    :disabled="!canRequest"
                >
                    <v-icon class="mr-2 v-icon-currency">mdi-currency-usd</v-icon>
                    {{ $tc('outgo.new') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row v-show="showFilters" class="mb-12">
            <Filters @onApply="searchListener" />
        </v-row>
        <div class="mt-6">
            <v-data-table
                :headers="headers"
                :items="deliveriesListResult.items"
                hide-default-footer
                show-select
                item-key="coverageId"
                id="table-gesta-remessas"
                class="elevation-0 pb-4 flat-container table-row-clickable"
                v-model="selectedRows"
            >
                <template slot="no-data">
                    <div>Não há dados</div>
                </template>

                <template v-slot:[`item.dueDate`]="{ item }">
                    {{ item ? formatDate(item.dueDate) : null }}
                </template>

                <template v-slot:[`item.issuedAt`]="{ item }">
                    {{ item ? formatDate(item.issuedAt) : null }}
                </template>

                <template v-slot:[`item.createdAt`]="{ item }">
                    {{ item ? formatDate(item.createdAt) : null }}
                </template>

                <template v-slot:[`item.value`]="{ item }">
                    {{ item ? formatarDinheiro(item.value) : null }}
                </template>

                <template v-slot:footer>
                    <v-pagination
                        color="secondary"
                        v-model="page"
                        class="mt-3"
                        :length="deliveriesListResult.totalPages"
                        :total-visible="7"
                    ></v-pagination>
                </template>
            </v-data-table>

            <Loader
                v-if="deliveriesListRequestStatus === RequestStatusEnum.START"
                class="text-center mt-3"
            />
        </div>
        <v-dialog content-class="modal-default modal-default-small" v-model="dialogOutgo">
            <header>
                {{ $tc('outgo.request') }}
                <v-icon role="button" title="Fechar" @click="closeModalOutgo" color="altPrimary"
                    >mdi-close-thick</v-icon
                >
            </header>
            <v-main class="pt-12">
                <section>
                    <v-menu
                        v-model="menuOutgoDate"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                label="Escolha uma data"
                                prepend-icon="event"
                                readonly
                                :value="outgoDateDisplay"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            locale="pt-br"
                            v-model="outgoDate"
                            no-title
                            scrollable
                            :min="minDate"
                            @input="menuOutgoDate = false"
                        >
                        </v-date-picker>
                    </v-menu>

                    <footer align="right" class="mt-6">
                        <v-btn @click="resetModalOutgoDate" color="secondary" depressed>
                            {{ $tc('defaults.form.redo') }}
                        </v-btn>
                        <v-btn
                            class="ml-3"
                            :disabled="!outgoDate"
                            @click="confirmModalOutgoDate"
                            color="secondary"
                            depressed
                        >
                            {{ $tc('defaults.form.confirm') }}
                        </v-btn>
                    </footer>
                </section>
            </v-main>
        </v-dialog>
    </v-main>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { RequestStatusEnum } from '@/helpers/consts';
import Loader from '@/components/base/Loader';
import MainFilter from '@/components/base/mainfilter/MainFilter';
import { formatDate } from '@/helpers/data';
import { formatarDinheiro } from '@/helpers/formatarDinheiro';
import headers from './_headersRemessas';
import Filters from '../components/_FiltersLista';
import { notification } from '@/helpers/notification';
export default {
    props: {
        outgoesFilterType: {
            type: String,
        },
    },
    components: {
        Loader,
        MainFilter,
        Filters,
    },
    computed: {
        ...mapGetters('gestao', {
            deliveriesListResult: 'deliveriesListResult',
            deliveriesListRequestStatus: 'deliveriesListRequestStatus',
            askForNewOutgoRequestStatus: 'askForNewOutgoRequestStatus',
            selectedProduct: 'selectedProduct',
            removeNFsByIdAndClientRequestStatus: 'removeNFsByIdAndClientRequestStatus',
            cancelOutgoRequestStatus: 'cancelOutgoRequestStatus',
        }),
        outgoDateDisplay() {
            return formatDate(this.outgoDate);
        },
        minDate() {
            return new Date().toISOString();
        },
    },
    data() {
        return {
            showFilters: false,
            filters: {
                page: 0,
                limit: 10,
            },
            page: 1,
            RequestStatusEnum,
            selectedRows: [],
            headers,
            dialogOutgo: false,
            menuOutgoDate: null,
            outgoDate: null,
            canRequest: false,
        };
    },
    methods: {
        ...mapActions('gestao', {
            fetchDeliveries: 'fetchDeliveries',
            askForNewOutgo: 'askForNewOutgo',
            fetchOpenOutgoes: 'fetchOpenOutgoes',
        }),
        filterInputChanged(value) {
            this.filters.nomeOuDoc = value;
            if (value.length >= 3 || value === '') {
                this.doSearch();
            }
        },
        toggleFilter() {
            this.showFilters = !this.showFilters;
        },
        doSearch() {
            this.lastSearchFilters = { ...this.filters };
            this.fetchDeliveries({
                idProduct: this.selectedProduct.id,
                filters: { ...this.filters },
            });
        },
        searchListener(data) {
            const nomeOuDoc = this.filters.nomeOuDoc || '';
            this.filters = { ...data, page: 0, limit: 10 };
            this.filters.nomeOuDoc = nomeOuDoc;
            this.doSearch();
        },
        formatarDinheiro,
        formatDate,
        onClickNewOutgo() {
            this.dialogOutgo = true;
        },
        closeModalOutgo() {
            this.resetModalOutgoDate();
            this.dialogOutgo = false;
        },
        confirmModalOutgoDate() {
            const ids = this.selectedRows.map(item => item.coverageId);
            this.askForNewOutgo({
                idProduct: this.selectedProduct.id,
                date: this.outgoDate,
                ids,
            });
            this.dialogOutgo = false;
        },
        resetModalOutgoDate() {
            this.outgoDate = null;
        },
    },
    mounted() {
        this.doSearch();
    },
    watch: {
        page() {
            this.filters.page = this.page - 1;
            this.doSearch();
        },
        selectedRows(data) {
            this.canRequest = Object.keys(data).length > 0;
        },
        askForNewOutgoRequestStatus(newValue) {
            if (newValue === RequestStatusEnum.START) {
                notification(this.$dialog.notify.warning, this.$tc('outgo.askForNew.start'));
                return RequestStatusEnum.START;
            }
            if (newValue === RequestStatusEnum.SUCCESS) {
                notification(this.$dialog.notify.success, this.$tc('outgo.askForNew.success'));
                this.fetchOpenOutgoes({
                    idProduct: this.selectedProduct.id,
                    status: '1,2',
                    filters: { tipo: this.outgoesFilterType },
                });
                this.selectedRows = [];
                this.doSearch();
                return RequestStatusEnum.SUCCESS;
            }
            if (newValue.type === RequestStatusEnum.ERROR) {
                notification(
                    this.$dialog.notify.error,
                    this.$t('outgo.askForNew.error', { msg: newValue.message })
                );
                return RequestStatusEnum.ERROR;
            }
        },
        removeNFsByIdAndClientRequestStatus(newValue) {
            if (newValue === RequestStatusEnum.SUCCESS) {
                this.doSearch();
            }
        },
        cancelOutgoRequestStatus(newValue) {
            if (newValue === RequestStatusEnum.SUCCESS) {
                this.doSearch();
            }
        },
    },
};
</script>
<style lang="scss">
@import '@/assets/scss/Sticky-table';
@include stickytable('#table-gesta-remessas', 2);
</style>